/* eslint-disable import/prefer-default-export */
export const companyConstants = {
  GET_COMPANY_REQUEST: 'COMPANIES_GET_COMPANY_REQUEST',
  GET_COMPANY_SUCCESS: 'COMPANIES_GET_COMPANY_SUCCESS',
  GET_COMPANY_FAILURE: 'COMPANIES_GET_COMPANY_FAILURE',

  SET_COMPANY: 'COMPANIES_SET_COMPANY',
  UNSET_COMPANY: 'COMPANIES_UNSET_COMPANY',

};
